<template>
<div>
  <table v-if="app_mode === 'advanced'" style="width: 100%" class="my-2 mt-4">
    <tr>
      <td>
        <v-alert @click="dialog.logs = true" v-if="service_status" :color="service_status.color" dark border="left" style="text-transform: uppercase; padding: 4px 16px;">
          <b>{{ service_status.title }}</b> <br/> {{ new Date(service_status.created_at).toLocaleDateString() }} às {{ new Date(service_status.created_at).toLocaleTimeString() }}
        </v-alert>
      </td>
      <td width="100px">
        <v-menu
          bottom
          offset-y
          max-height="450px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              style="margin-bottom: 16px; height: 56px"
              color="primary"
              depressed
              outlined
              block
            ><v-icon>mdi-list-status</v-icon></v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(status, i) in service_status_select"
              :key="i"
              @click="updateServiceStatus(status)"
            >
              <v-list-item-title v-if="i !== 'created'">{{ status.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </table>
  <LogsDialog :open="dialog.logs" :logs="logs" :vehicle="service_order.vehicle" @close-dialog="closeDialog"/>
  <h3 class="mt-0 mb-4">Observação do cliente</h3>
  <div>
    <v-textarea
      v-model="service_description"
      v-debounce:3s="saveClientDescription"
      @input="saveDescriptionLoading"
      :disabled="status === 'finished' || status === 'canceled'"
      class="mb-5"
      color="#48B38B"
      placeholder="Digite aqui o relato do cliente..."
      outlined
      height="150px"
      hide-details
      style="width: calc(100% - 35px); float: left;"
    ></v-textarea>
    <button
      v-if="status !== 'finished' && status !== 'canceled'"
      @click="recognitionVoice('service_description')"
      :class="{'voice-recognition': true, 'recording': speechToText.isRecognizing && speechToText.target === 'service_description'}"
      style="cursor: pointer; width: 30px; height: 150px; margin-left: 5px; text-align: center; border: 1px dashed rgba(0, 0, 0, 0.4); border-radius: 6px;"
    >
      <div :key="speechToText.isRecognizing">
        <div v-if="speechToText.isRecognizing && speechToText.target === 'service_description'">
          <v-icon size="28" color="#fff">mdi-microphone</v-icon>
        </div>
        <div v-else>
          <v-icon size="28">mdi-microphone</v-icon>
        </div>
      </div>
    </button>
  </div>

  <h3 class="my-4">Observação da oficina</h3>
  <div>
    <v-textarea
      v-model="organization_observation"
      v-debounce:3s="saveOrganizationObservation"
      @input="saveDescriptionLoading"
      :disabled="status === 'finished' || status === 'canceled'"
      class="mb-5"
      color="#48B38B"
      placeholder="Digite aqui o diagnóstico geral e observações..."
      outlined
      height="150px"
      hide-details
      style="width: calc(100% - 35px); float: left;"
    ></v-textarea>
    <button
      v-if="status !== 'finished' && status !== 'canceled'"
      @click="recognitionVoice('organization_observation')"
      :class="{'voice-recognition': true, 'recording': speechToText.isRecognizing && speechToText.target === 'organization_observation'}"
      style="cursor: pointer; width: 30px; height: 150px; margin-left: 5px; text-align: center; border: 1px dashed rgba(0, 0, 0, 0.4); border-radius: 6px;"
    >
      <div :key="speechToText.isRecognizing">
        <div v-if="speechToText.isRecognizing && speechToText.target === 'organization_observation'">
          <v-icon size="28" color="#fff">mdi-microphone</v-icon>
        </div>
        <div v-else>
          <v-icon size="28">mdi-microphone</v-icon>
        </div>
      </div>
    </button>
  </div>

  <h3 class="my-4">Aúdios armazenados</h3>

  <AudioRecorder :serviceOrderId="service_order_id" entity="workshop" @audio-uploaded="handleAddAudio" />

  <div v-if="workshopAudios.length > 0" class="audio-list mt-2">
    <AudioPlayer
      v-for="audio in workshopAudios"
      :key="audio.id"
      :audio="audio"
      @open="openAudio"
    />
  </div>

  <h3 class="mt-4 mb-2">Responsáveis</h3>
  <v-list-item class="px-0">
    <v-list-item-avatar>
      <v-icon class="grey lighten-1" dark>mdi-account</v-icon>
    </v-list-item-avatar>
    <v-list-item-content v-if="created_by_user">
      <v-list-item-title><b>{{ created_by_user.name }}</b></v-list-item-title>
      <v-list-item-subtitle>Criou o Relatório de serviço</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
  <v-list-item v-for="(responsible, index) in responsibles" :key="index" class="px-0 mb-2">
    <v-list-item-avatar>
      <v-icon class="grey lighten-1" dark>mdi-account</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title><b>{{ responsible.name }}</b></v-list-item-title>
      <v-list-item-subtitle>Trabalhou no Relatório de serviço</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn v-if="status !== 'finished' && status !== 'canceled'" @click="removeResponsible(responsible)" icon>
        <v-icon color="grey lighten-1">mdi-delete</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
      <div style="display: flex; gap: 10px;">
      <div class="box mb-5" style="flex: 1;">
        <div
          v-if="status !== 'finished' && status !== 'canceled'"
          @click="isLastResponsibleCurrentUser ? null : attachCurrentUser()"
          :class="['add', { 'disabled-button': isLastResponsibleCurrentUser }]"
          :style="isLastResponsibleCurrentUser ? 'background-color: #ccc; opacity: 0.4; cursor: not-allowed;' : ''"
        >
          SE ATRELAR
        </div>
      </div>
      <div class="box mb-5" style="flex: 1;">
        <div v-if="status !== 'finished' && status !== 'canceled'" @click="dialog.responsible = true" class="add">
          ESPECIFICAR
        </div>
      </div>
    </div>
  <ResponsibleDialog v-if="dialog.responsible" :open="dialog.responsible" @close-dialog="closeDialog"/>
  <h3 class="my-2" v-if="app_mode === 'advanced'">Deletar R.S.</h3>
  <v-dialog
    v-if="app_mode === 'advanced'"
    v-model="dialog_delete"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="mt-4"
        outlined
        large
        block
        color="red"
      >
        Deletar Relatório de Serviço
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 grey darken-1" style="color: #fff">
        Deletar R.S.
      </v-card-title>

      <v-card-text class="pt-4">
        Tem certeza que deseja deletar o relatório de serviço? Os links compartilhados da R.S. não vão mais funcionar e ela ficara em backup caso necessário seja recuperar. O serviço continua sendo contabilizado na assinatura mensal a menos que seja solicitada a exclusão definitiva por um responsável da empresa através de e-mail.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          @click="dialog_delete = false"
          color="grey darken-1"
          elevation="0"
          dark
          style="width: 60%"
        >
          Cancelar
        </v-btn>
        <v-btn
          @click="deleteOS()"
          color="red"
          elevation="0"
          dark
          style="width: 40%"
        >
          Deletar R.S.
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-if="app_mode === 'advanced'"
    v-model="isRemoveAudioModalActive"
  >
    <v-card>
      <v-card-title class="text-h5 grey darken-1" style="color: #fff">
        Excluir áudio
      </v-card-title>

      <v-card-text class="pt-4">
        Tem certeza que deseja excluir o áudio?
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          @click="isRemoveAudioModalActive = false"
          color="grey darken-1"
          elevation="0"
          dark
          style="width: 60%"
        >
          Cancelar
        </v-btn>
        <v-btn
          @click="confirmRemoveAudio()"
          color="red"
          elevation="0"
          dark
          style="width: 40%"
        >
          Excluir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <RecognitionVoiceService v-if="speechToText.isRecognizing" @recognized-voice="handleSpeechRecognitionResult" @cancel="cancelRecognizeVoice" />

  <AudioDetails :isActive="isOpenAudioModalActive" :audio="audioToOpen" @close="isOpenAudioModalActive = false" @save="saveAudio" @remove="removeAudio" />
</div>
</template>

<script>
import ServiceOrderAudioService from '@/services/api/serviceOrderAudio';
import ResponsibleDialog from './Dialogs/ResponsibleDialog';
import LogsDialog from './Dialogs/LogsDialog';

import RecognitionVoiceService from '../Common/RecognitionVoiceService';

import AudioRecorder from '../Common/AudioRecorder';
import AudioPlayer from '../Common/AudioPlayer';
import AudioDetails from '../Common/AudioDetails';

export default {
  props: {
    service_order_id: Number
  },
  components: {
    ResponsibleDialog,
    LogsDialog,
    AudioRecorder,
    AudioPlayer,
    AudioDetails,
    RecognitionVoiceService,
  },
  data: () => ({
    user_logged: null,
    dialog: {
      responsible: false,
      logs: false
    },
    dialog_delete: false,
    isOpenAudioModalActive: false,
    audioToOpen: null,
    isRemoveAudioModalActive: false,
    audioToRemove: null,
    service_description: '',
    organization_observation: '',
    speechToText: {
      target: null,
      recognition: null,
      isRecognizing: false,
    },
  }),
  mounted() {
    this.user_logged = this.$store.getters['Auth/user'];

    if (this.service_order.id) {
      this.service_description = this.service_order.description || '';
      this.organization_observation = this.service_order.organization_observation || '';
    }
  },
  computed: {
    app_mode() {
      return localStorage.getItem('app_mode') || 'advanced';
    },
    service_status_list () {
      return this.$store.getters['General/organization_status_list'];
    },
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    logs() {
      return this.$store.getters['ServiceOrder/logs'];
    },
    status() {
      return this.$store.getters['ServiceOrder/status'];
    },
    service_status() {
      const status = this.service_status_list.find(( status ) => status.code === this.status);
      const log = this.logs.filter(( log ) => log.description === this.status).pop();
      return status && log ? {...status, created_at: log.created_at } : false;
    },
    service_status_select() {
      return this.service_status_list.filter(( status ) => status.ref !== 'created');
    },
    created_by_user() {
      return this.$store.getters['ServiceOrder/created_by_user'];
    },
    responsibles() {
      return this.$store.getters['ServiceOrder/responsibles'];
    },
    clientAudios() {
      if (!this.service_order.service_order_audios) return [];

      const clientAudios = this.service_order.service_order_audios.filter(audio => audio.tag.includes('client'));

      clientAudios.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      return clientAudios;
    },

    workshopAudios() {
      if (!this.service_order.service_order_audios) return [];

      const workshopAudios = this.service_order.service_order_audios.filter(audio => audio.tag.includes('workshop'));

      workshopAudios.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      return workshopAudios;
    },
    isLastResponsibleCurrentUser() {
      if (!this.user_logged) return false;

      if ((!this.responsibles || this.responsibles.length === 0) &&
          this.created_by_user && this.created_by_user.id === this.user_logged.id) {
        return true;
      }

      if (this.responsibles && this.responsibles.length > 0) {
        const lastResponsible = this.responsibles[this.responsibles.length - 1];
        return lastResponsible && lastResponsible.id === this.user_logged.id;
      }

      return false;
    },
  },
  methods: {
    cancelRecognizeVoice() {
      this.speechToText = {
        target: null,
        recognition: null,
        isRecognizing: false,
      };
    },
    recognitionVoice(target) {
      this.speechToText.target = target;
      this.speechToText.isRecognizing = true;
    },
    handleSpeechRecognitionResult(result) {
      if (!result || typeof result !== 'string') {
        console.warn('Resultado de reconhecimento de voz inválido:', result);
        this.speechToText.isRecognizing = false;
        return;
      }

      if (!this.speechToText.target) {
        console.warn('Target de reconhecimento de voz não definido');
        this.speechToText.isRecognizing = false;
        return;
      }

      // Inicializa o campo se necessário e adiciona o resultado
      if (this[this.speechToText.target] === null || this[this.speechToText.target] === undefined) {
        this[this.speechToText.target] = '';
      } else if (this[this.speechToText.target].length > 0) {
        this[this.speechToText.target] += '\n';
      }
      this[this.speechToText.target] += result;
      this.speechToText.isRecognizing = false;
      if (this.speechToText.target === 'service_description') {
        this.saveClientDescription();
      } else {
        this.saveOrganizationObservation();
      }
    },
    getOrganizationParameter(code) {
      const parameter = this.user_logged.organization.organization_parameters.find((parameter) => parameter.code === code);
      return parameter ? parameter.value : false;
    },
    updateServiceStatus(status) {
      if (this.getOrganizationParameter('AUTOMATIC_ATTACH_RESPONSIBLE')) {
        if (this.user_logged.id !== this.created_by_user.id && !this.responsibles.some(user => user.id === this.user_logged.id)) {
          this.$store.dispatch('ServiceOrder/saveResponsible', this.user_logged);
        }
      }
      if (status.ref !== 'finished') {
        this.$store.dispatch('ServiceOrder/saveServiceStatus', status);
      } else if (this.$store.getters['ServiceOrder/checklist_warning']) {
        this.$store.dispatch('ServiceOrder/saveServiceStatus', status);
      } else {
        this.$toast.error('Verifique os checklists antes de finalizar');
        this.$store.dispatch('ServiceOrder/updateChecklistWarning', true);
        this.$emit('changeTab', 3);
      }
    },
    saveDescriptionLoading() {
      this.$store.dispatch('ServiceOrder/setDescriptionLoading', true);
    },
    saveClientDescription() {
      this.$store.dispatch('ServiceOrder/saveClientDescription', this.service_description);
    },
    saveResponsible(data) {
      this.$store.dispatch('ServiceOrder/setLoading', true);
      this.$store.dispatch('ServiceOrder/saveResponsible', data);
    },
    removeResponsible(responsible) {
      this.$store.dispatch('ServiceOrder/setLoading', true);
      this.$store.dispatch('ServiceOrder/removeResponsible', responsible);
    },
    attachCurrentUser() {
      this.$store.dispatch('ServiceOrder/setLoading', true);
      this.$store.dispatch('ServiceOrder/saveResponsible', this.user_logged);
    },
    closeDialog(dialog) {
      if (dialog.entity === 'logs') {
        this.dialog.logs = false;
      } else if (dialog.entity === 'responsible') {
        if (dialog.data) {
          this.saveResponsible(dialog.data);
        }
        this.dialog.responsible = false;
      }
    },
    saveOrganizationObservation() {
      this.$store.dispatch('ServiceOrder/saveOrganizationObservation', this.organization_observation);
    },
    deleteOS() {
      const self = this;
      self.$store.dispatch('ServiceOrder/setLoading', true);
      self.$http.delete(`/service_order/${self.service_order_id}/disable`).then(() => {
        self.$emit('closeServiceFlow');
      });
    },
    handleAddAudio(audio) {
      this.$store.dispatch('ServiceOrder/addAudio', audio);
    },
    openAudio(audio) {
      this.audioToOpen = audio;
      this.isOpenAudioModalActive = true;
    },
    saveAudio(audio) {
      this.$store.dispatch('ServiceOrder/setLoading', true);

      const serviceOrderId = this.service_order_id;
      const audioId = audio.id;

      const form = {
        observation: audio.observation,
        visible: audio.visible,
      };

      const data = {
        ...form,
        service_order_id: serviceOrderId,
      };

      ServiceOrderAudioService.update(serviceOrderId, audioId, data)
        .then(() => {
          this.$toast.success('Observação atualizada com sucesso');

          this.isOpenAudioModalActive = false;

          this.$store.dispatch('ServiceOrder/setLoading', false);
        })
        .catch((error) => {
          this.$toast.error('Erro ao atualizar observação');
          console.error(error);
        })
        .finally(() => {
          this.$store.dispatch('ServiceOrder/setLoading', false);
        });
    },
    removeAudio(audio) {
      this.isRemoveAudioModalActive = true;

      this.audioToRemove = audio;
    },
    confirmRemoveAudio() {
      this.$store.dispatch('ServiceOrder/removeAudio', this.audioToRemove.id);

      this.isRemoveAudioModalActive = false;
      this.isOpenAudioModalActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.voice-recognition {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &.recording {
    color: #fff;
    background-color: #48b38b;
    border-color: #48b38b;
  }
}

.disabled-button {
  pointer-events: none;
}
</style>
